
import { api_host,api_auth} from '../../common/globals/constants';


export const getAvailabilityObjetive = (objetivo_id, period, id_user, token) => fetch(api_host+`/reporte/online/indicadores/getDisponibility/?user=${id_user}&key=${api_auth}&objetivoId=${objetivo_id}&t=${period}&token=${token}`)
.then(response => response.json())
